import Modal from '../src/components/modal/Modal'

function App() {
  return (
    <div className="App">
        <Modal />
    </div>
  );
}

export default App;
